export const assistBarLongException = (state) => {
    if (state.sidePanel === "With Side Panels") {
        return "Non disponible avec longs pans";
    }
    return null;
};
